// extracted by mini-css-extract-plugin
export default {"item":"style_item__7DMVX","top":"style_top__YY-Xp","text":"style_text__YAMEu","notion":"style_notion__iSh8V"};